const engineers = {
  icon: 'UsersIcon',
  title: 'Engineers Directory',
  subtitle: 'Manage, track and explore your engineering team in real time.',
  // `key` links a card to the live value the page passes to <MainHeader :stats-values="{ ... }" />
  // `value` is only the fallback shown until that live value arrives
  stats: [
    {
      key: 'totalRows',
      icon: 'UsersIcon',
      label: 'Total Engineers',
      value: '0',
    },
    {
      key: 'totalActiveLoad',
      icon: 'ActivityIcon',
      label: 'Active Load',
      value: '0',
    },
    {
      key: 'uniqueDepartments',
      icon: 'BriefcaseIcon',
      label: 'Departments',
      value: '0',
    },
    {
      key: 'uniqueOffices',
      icon: 'GlobeIcon',
      label: 'Offices',
      value: '0',
    },
  ],
}

export default engineers
